import ListItem from "@mui/material/ListItem";
import {
  TextField,
  SelectField,
  BooleanField,
  FunctionField,
} from "react-admin";
import { styled } from "@mui/material/styles";

export const ListItemField = styled(ListItem)(() => ({
  alignItems: "flex-start",
  borderBottom: "1px solid #d9d9d9",
  userSelect: "none",
}));

export const HeaderField = styled(TextField)(({ theme, flexbasis }) => ({
  paddingRight: theme.spacing(2),
  fontWeight: theme.typography.fontWeightBold,
  flex: `0 0 ${theme.spacing(flexbasis)}`,
}));

export const IsPublishedHeaderField = styled(HeaderField)(({ theme }) => ({
  paddingRight: theme.spacing(5.25),
}));

export const PreviewHeaderField = styled(TextField)(({ theme }) => ({
  flex: "1 1 auto",
  paddingLeft: theme.spacing(2),
  fontWeight: theme.typography.fontWeightBold,
}));

export const IdField = styled(TextField)(({ theme }) => ({
  flex: `0 0 ${theme.spacing(5)}`,
  paddingRight: theme.spacing(2),
}));

export const ContentTypeField = styled(SelectField)(({ theme }) => ({
  paddingRight: theme.spacing(2),
  flex: `0 0 ${theme.spacing(11)}`,
}));

export const PreviewField = styled(TextField)(({ theme }) => ({
  flex: "1 1 auto",
  paddingLeft: theme.spacing(2),
}));

export const IsPublishedField = styled(BooleanField)(({ theme }) => ({
  paddingRight: theme.spacing(10),
}));

export const ContentItemTypeField = styled(SelectField)(({ theme }) => ({
  paddingRight: theme.spacing(2),
  flex: `0 0 ${theme.spacing(16)}`,
}));

export const PreviewContentItemField = styled(FunctionField)(({ theme }) => ({
  flex: "1 1 auto",
  paddingLeft: theme.spacing(2),
}));

export const NameField = styled(TextField)(({ theme }) => ({
  paddingRight: theme.spacing(2),
  flex: `0 0 ${theme.spacing(13)}`,
}));
